import { FC } from "react";
import css from './index.module.css';

interface Tab {
  id: number | string,
  name: string
}

interface Tabs {
  sections: Tab[]
  active?: number
  setActive?: any
  isFull?: boolean
  vertical?: boolean
}

const Tabs:FC<Tabs> = ({ sections, active, setActive, isFull, vertical }) => {
  return (
    <div className={css.sections} style={vertical ? { flexDirection: 'column' } : {}}>
      {sections.map(section => (
        <div className={`${css.section} ${active === section.id ? css.active : ''}`} style={isFull ? { width: "100%", textAlign: 'center' } : {}} onClick={() => setActive(section.id)}>{section.name}</div>
      ))}
    </div>
  );
};

export default Tabs;